import { useSearchParams } from 'next/navigation'
import { franchiseLocationQueryParamName } from '../../../../../common/constants/queryParams'
import * as React from 'react'
import { useFranchiseLocations } from './useFranchiseLocations'

export function useSignUpCompoundFranchiseLocationData() {
  const params = useSearchParams()
  const franchiseLocationQueryParam = params?.get(franchiseLocationQueryParamName)

  const { franchiseLocationOptions } = useFranchiseLocations()

  return React.useMemo(() => {
    const franchiseLocation = franchiseLocationOptions.find((x) => x.label === franchiseLocationQueryParam)
    return franchiseLocation
      ? { compound_franchise_location: `${franchiseLocation.country}|${franchiseLocation.value}` }
      : null
  }, [franchiseLocationOptions, franchiseLocationQueryParam])
}
